module.exports = __webpack_public_path__ + "assets/img/station25.bc726fa5.png";